<template>
  <form ref="withdrawForm" @submit.prevent="() => false">
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <label>Withdrawal Date</label>
        <el-date-picker v-model="date" format="dd/MM/yyyy" value-format="dd/MM/yyyy" type="date" placeholder="Pick a day"></el-date-picker>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <label>Main Reason</label>
        <select v-model="mainReason" class="form-control pro-edt-select form-control-primary">
          <option v-for="item in mainReasonList">{{ item }}</option>
        </select>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" v-if="showSchoolSelect">
        <label>School Name</label>
        <select v-model="school" class="form-control pro-edt-select form-control-primary" required>
          <option v-for="item in schoolList">{{ item }}</option>
        </select>
        <input v-if="school === 'Others'" type="text" class="form-control" v-model="schoolText" required />
      </div>
      <!--            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" v-if="showSchoolNameInput">-->
      <!--                <label>School Name</label>-->
      <!--                <input type="text" class="form-control" required v-model="schoolText"/>-->
      <!--            </div>-->
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" v-if="showOptionalRemarks">
        <label>Remarks (Optional)</label>
        <input type="text" class="form-control" v-model="reason1Text" />
      </div>
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" v-if="showReasonsSelect">
        <label>Reason 1</label>
        <select v-model="reason1" class="form-control pro-edt-select form-control-primary" required>
          <option v-for="item in reason1List">{{ item }}</option>
        </select>
        <input v-if="reason1 === 'Others'" type="text" class="form-control" v-model="reason1Text" required />
      </div>
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" v-if="showReasonsSelect">
        <label>Reason 2</label>
        <select v-model="reason2" class="form-control pro-edt-select form-control-primary">
          <option v-for="item in reason2List">{{ item }}</option>
        </select>
        <input v-if="reason2 === 'Others'" type="text" class="form-control" v-model="reason2Text" />
      </div>
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" v-if="showReasonsSelect">
        <label>Reason 3</label>
        <select v-model="reason3" class="form-control pro-edt-select form-control-primary">
          <option v-for="item in reason3List">{{ item }}</option>
        </select>
        <input v-if="reason3 === 'Others'" type="text" class="form-control" v-model="reason3Text" />
      </div>
    </div>
    <div class="row custom-modal-footer" style="padding: 20px 0 10px; background: none">
      <div class="col-lg-6">
        <button @click="$emit('close')" class="btn btn-secondary float-left">Cancel</button>
      </div>
      <div class="col-lg-6">
        <button @click="submit()" class="btn btn-primary float-right btnFamilyIDSearch">Withdraw</button>
      </div>
    </div>
  </form>
</template>

<script>
import { schoolListMIS } from '@/pages/withdrawal/component/withdrawReason'

export default {
  name: 'StudentWithdrawForm',
  data() {
    return {
      date: null,
      mainReason: '',
      school: '',
      schoolText: '',
      reason1: '',
      reason1Text: '',
      reason2: '',
      reason2Text: '',
      reason3: '',
      reason3Text: '',
    }
  },
  watch: {
    date(val) {
      this.$emit('date', val)
    },
    mainReason(val) {
      this.$emit('main-reason', val)
    },
    school(val) {
      this.$emit('school', val)
    },
    schoolText(val) {
      this.$emit('school', val)
    },
    reason1(val) {
      this.$emit('reason1', val)
    },
    reason1Text(val) {
      this.$emit('reason1', val)
    },
    reason2(val) {
      this.$emit('reason2', val)
    },
    reason2Text(val) {
      this.$emit('reason2', val)
    },
    reason3(val) {
      this.$emit('reason3', val)
    },
    reason3Text(val) {
      this.$emit('reason3', val)
    },
  },
  computed: {
    showSchoolSelect() {
      return [
        'Transfer to another local/international Pre-School',
        'Transfer to another International Primary',
        'Transfer to another International Secondary',
        'Withdrawing from EtonHouse campus and enrolling to Middleton International School',
      ].includes(this.mainReason)
    },
    showSchoolNameInput() {
      return ['Transfer to another Etonhouse International School/Preschool'].includes(this.mainReason)
    },
    showOptionalRemarks() {
      return ['Moving to another location in SG'].includes(this.mainReason)
    },
    showReasonsSelect() {
      return this.showSchoolSelect
    },
    mainReasonList() {
      return [
        'Transfer to another local/international Pre-School',
        'Transfer to another International Primary',
        'Transfer to another International Secondary',
        'Transfer to a local Primary',
        'Repratriating to home country',
        'Transfer outside SG',
        'Transfer to another Etonhouse International School/Preschool',
        'Moving to another location in SG',
      ]
    },
    subReasonList() {
      return [
        `Curriclum: Not academic enough`,
        `Curriclum: Too Academic`,
        `Curriclum: Quality of the teaching and learning`,
        `Curriclum: Quality and Frequency of assessments and feedback`,
        `Curriclum: Not enough sports in timetable`,
        `Curriclum: Preparation for Primary School`,
        `Curriclum: Unable to provide learning support`,
        `Facilities: Not enough Sports`,
        `Facilities: Not enough outdoor space`,
        `Facilities: Not enough communal spaces (library, auditorium, dining)`,
        `Facilities: Not enough IT resources`,
        `Fees: Increased too much`,
        `Fees: Change in financial situation`,
        `Fees: Looking for cheaper school`,
        `Language: Want more Language learning time`,
        `Language: Not happy with language acquisition`,
        `Language: More options`,
        `Logistics: Need longer School hours`,
        `Logistics: No bus service`,
        `Logistics: Not a good selection of After school Activities`,
        `Logistics: Too many holidays in Academic Year`,
        `Logistics: No Childcare options`,
        `School Community: Not diverse enough`,
        `School Community: Not inclusive enough`,
        `School Community: Not enough Community feel`,
        `School philosophy: Disagree with Behavior guidance policies`,
        `School philosophy: Disagree with Classroom management`,
        `Staff: Issue with Staff Member`,
        `Staff: High Turnover`,
        `Other: School Transition: Need to secure place in Primary`,
        `Other: School Transition: Need to secure place in Secondary`,
        `Other: Parent did not disclose`,
        `Others`,
      ]
    },
    schoolList() {
      if (['Withdrawing from EtonHouse campus and enrolling to Middleton International School'].includes(this.mainReason)) {
        return schoolListMIS
      } else {
        return [
          `Anglo-Chinese School`,
          `Ascensia International School`,
          `Astor International School`,
          `Australian International School`,
          `Avondale Grammer`,
          `Bluehouse`,
          `Brighton`,
          `Canadian International School`,
          `Chatsworth`,
          `Dimensions international College`,
          `Dover Court`,
          `DPS International School`,
          `Dulwich College`,
          `French International School`,
          `GEMS World Academy`,
          `German European International School`,
          `Global Indian School`,
          `International Community School`,
          `International School Singapore`,
          `Invictus`,
          `Japanese International School`,
          `Kiddiewinkie`,
          `Korean International School`,
          `Mindchamps`,
          `My First Campus`,
          `Nexus`,
          `North London Collegiate School`,
          `NPS International School`,
          `Odyssey The Global Preschool`,
          `Olympiad International School`,
          `One World`,
          `Overseas Family School`,
          `Shaw's`,
          `Singapore American School`,
          `St. Joseph International School`,
          `Stamford American International School`,
          `Superland`,
          `Swiss School`,
          `Tanglin Trust`,
          `Undeclared`,
          `UWCSEA`,
          `XCL American Academy`,
          `Others`,
        ]
      }
    },
    reason1List() {
      return this.subReasonList.filter(r => r === 'Others' || ![this.reason2, this.reason3].includes(r))
    },
    reason2List() {
      return this.subReasonList.filter(r => r === 'Others' || ![this.reason1, this.reason3].includes(r))
    },
    reason3List() {
      return this.subReasonList.filter(r => r === 'Others' || ![this.reason1, this.reason2].includes(r))
    },
  },
  methods: {
    submit() {
      if (this.$refs.withdrawForm.reportValidity()) {
        this.$emit('submit')
      }
      return false
    },
  },
}
</script>
